import { HttpHeaders, HttpRequest, type HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { constantVariables } from '@shared/helper/configs';
import { GeneralService } from '@shared/services/general.service';

export const headerInterceptor: HttpInterceptorFn = (req, next) => {
  const generalService = inject(GeneralService);

  let headers = req.headers;
  headers = handleAccessTokenHeader(generalService, headers);
  headers = handleVisitorIdHeader(headers);
  headers = handleRefreshTokenHeader(generalService, req, headers);
  headers = handleTempTokenHeader(generalService, req, headers);
  headers = handleSourceProductHeader(generalService, req, headers);
  return next(req.clone({ headers }));
};

const getVid = () => {
  const generalService = inject(GeneralService);
  if (generalService.isBrowserOnly) {
    return localStorage.getItem(constantVariables.visitorId);
  }
  return null;
};

const handleAccessTokenHeader = (generalService: GeneralService, headers: HttpHeaders) => {
  if (generalService.isBrowserOnly) {
    const atk = localStorage.getItem(constantVariables.accessToken);
    if (atk) {
      return headers.append('atk', atk);
    }
  }
  return headers;
};

const handleVisitorIdHeader = (headers: HttpHeaders) => {
  const vid = getVid();
  if (vid) {
    return headers.append('x-visitor-id', vid);
  }
  return headers;
};

const handleTempTokenHeader = (
  generalService: GeneralService,
  req: HttpRequest<any>,
  headers: HttpHeaders,
) => {
  if (generalService.isBrowserOnly) {
    if (
      ['terminateDeviceSessionWithTempToken', 'getMyDevicesWithTempToken', 'loginWithTmt'].includes(
        req.body.operationName,
      )
    ) {
      const tmt = localStorage.getItem(constantVariables.tempToken);
      if (tmt) {
        return headers.append('tmt', tmt);
      }
    }
  }
  return headers;
};

const handleRefreshTokenHeader = (
  generalService: GeneralService,
  req: HttpRequest<any>,
  headers: HttpHeaders,
) => {
  if (generalService.isBrowserOnly) {
    if (['refreshToken', 'logout'].includes(req.body.operationName)) {
      const rtk = localStorage.getItem(constantVariables.refreshToken);
      if (rtk) {
        return headers.append('rtk', rtk);
      }
    }
  }
  return headers;
};

const handleSourceProductHeader = (
  generalService: GeneralService,
  req: HttpRequest<any>,
  headers: HttpHeaders,
) => {
  return headers.append('x-source', '924118');
};
